import React, { createContext, useContext, useState } from "react";
import type { ReactNode } from "react";

// Define the shape of the context state and updater
interface SessionStatusContextType {
  sessionStatus: number;
  setSessionStatus: React.Dispatch<React.SetStateAction<number>>;
}

// Create context with proper typing — initially undefined
const SessionStatusContext = createContext<
  SessionStatusContextType | undefined
>(undefined);

interface SessionStatusProviderProps {
  children: ReactNode;
}

// Provider component that holds the global state
export const SessionStatusProvider: React.FC<SessionStatusProviderProps> = ({
  children,
}) => {
  const [sessionStatus, setSessionStatus] = useState<number>(2);

  return (
    <SessionStatusContext.Provider value={{ sessionStatus, setSessionStatus }}>
      {children}
    </SessionStatusContext.Provider>
  );
};

// Custom hook to consume the context with type safety
export const useSessionStatus = (): SessionStatusContextType => {
  const context = useContext(SessionStatusContext);
  if (!context) {
    throw new Error(
      "useSessionStatus must be used within a SessionStatusProvider",
    );
  }
  return context;
};
